<template>
    <div class="LH-wrapper clearfix" id="LH-wrapper">
        <div class="LH-left fl">
            <!-- <a href="http://www.academicpub.org/" target="_blank"> -->
                <img class="LH-waplogo" src="../assets/sas2.jpg" alt="">
            <!-- </a> -->

            <ul class="LH-green">
                <li>
                    <router-link to="/SubmissionGuidelines">Author Guidelines</router-link>
                </li>
                <li>
                    <a href="http://onlinesystem.subisaic.com" target="_blank">Welcome to contribute</a>
                </li>
                <!-- <li>
                    <a href="#" target="_blank">Contribute</a>
                </li> -->
            </ul>

            <ul class="LH-menu">
                <li><router-link to="/Home">Home</router-link></li>
                <li><router-link to="/FocusAndScope">Focus and Scope</router-link></li>
                <li><router-link to="/EditorialBoard">Editorial Board</router-link></li>
                <li><router-link to="/PeerReiew">Peer Reiew</router-link></li>
                <li><router-link to="/ReiewProcess">Reiew Process</router-link></li>
                <li><router-link to="/OpenAccess">Open Access</router-link></li>
                <li><router-link to="/AboutThePublisher">About the Publisher</router-link></li>
                <li><router-link to="/ContactUs">Contact Us</router-link></li>
                <!-- <li><a href="http://www.academicpub.org/Browse.aspx" target="_blank">Other Journals</a></li> -->
            </ul>

            <a href="http://onlinesystem.subisaic.com" target="_blank">
                <img src="../assets/submitbutton.jpg" alt="" width="185" height="45" style="margin-top: 5px;">
            </a>


            <div class="all-issues">All Issues</div>
            <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>

        </div>
        <div class="LH-right fr">
            <div class="LH-topic">
                <span class="LH-topic-text">International Journal of Automation Information and Computing</span>
                <!-- <img src="../assets/OpenAccesslogo.png" alt="" width="100" height="36"> -->
            </div>
            <div class="LH-mid flex-display">
                <img src="../assets/b1.png" alt="" width="120" height="160">
                <div class="LH-introduce">
                    <div class="border-bottom">
                        <h3>An Open Access Journal</h3>
                        
                        <p class="LH-introduce-p">
                            <span class="LH-introduce-text">Frequency: Annually</span>
                        </p>
                        <p class="LH-introduce-p">
                            <span class="LH-introduce-text" style="width: 90%;">Publisher: Shimeng Academic Service </span>
                            <!-- <span class="LH-introduce-text">ISSN: 2224-7777(Online)</span> -->
                        </p>
                    </div>
                    <div>
                        <h3>Editor-in-Chief: <span class="LH-introduce-text">Prof. Shiping Wen,</span></h3>
                        <p class="LH-introduce-p">
                            <span class="LH-introduce-text">University of Technology Sydney, Australia.</span>
                        </p>
                    </div>

                    <div class="bshare-custom">
                        <a class="bshare-gplus" href="javascript:void(0);" title="Google+"></a>
                        <a class="bshare-facebook" href="javascript:void(0);" title="Facebook"></a>
                        <a class="bshare-instapaper" href="javascript:void(0);" title="Instapaper"></a>
                        <a class="bshare-msn" href="javascript:void(0);" title="Msn"></a>
                        <a class="bshare-twitter" href="javascript:void(0);" title="Twitter"></a>
                        <a class="bshare-reddit" href="javascript:void(0);" title="Reddit"></a>
                    </div>
                </div>
                <ul class="LH-main-button">
                        <li>
                            <span >ISSN:2709-2887(online)</span>
                            <span >Int.J.Autom.Inf.Comput.</span>
                            <span >  Hong Kong</span> 
                            <!-- &nbsp;&nbsp; &nbsp; &nbsp;    -->
                            <span>Impact factors: </span>
                        </li>
                    </ul>
            </div>
            <div>
                <router-view></router-view>
            </div>
            <div class="LH-footer">
                <p>
                    Copyright © 2020 Shimeng Academic Service - All rights reserved.
                </p>
                <p>
                    Email:
                    <a href="mailto:academic@confiswee.com">academic@confiswee.com</a>
                    <!-- <a href="mailto:journal@ij-ep.org "> journal@ij-ep.org</a> -->
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '../router'
    export default {
        name: "Layout",
        components: {
            
        },
        mounted() {
            
        },
        data() {
            return {
                data: [{
                    label: 'Online First',
                    path: '/onlineFirst'
                    }, {
                    label: '2020',
                    children: [{
                        label: '2020-01',
                        path: '/issue202001'
                    }]
                    }, 
                    // {
                    // label: '2019',
                    // children: [{
                    //     label: '2019-01',
                    //     path: '/issue201901'
                    // }]
                    // }
                    ],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            };
        },
        methods: {
            handleNodeClick(data) {
                console.log(data);
                router.push({ path: data.path })
            }
        }
    };
</script>

<style scoped>
.LH-wrapper{
    width: 1032px;
    /* height: 100%; */
    background-image: url("../assets/JCET_bg.jpg");
    background-repeat: repeat-y;
    margin: 0 auto;
    position: relative;
}

.LH-left {
    width: 234px;
    height: 1000px;
    text-align: center;
}
.LH-waplogo {
    width: 150px;
    margin-top: 5px;
}
.LH-green{
    background-image: url("../assets/ET_green.jpg");
    background-repeat: no-repeat;
    height: 180px;
    width: 234px;
    padding: 0;
    padding-top: 35px;
    box-sizing: border-box;
}
.LH-green li a{
    text-decoration: none;
    color: #FFF;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 15px;
    font-weight: bold;
    line-height: 35px;
    text-align: left;
}
.LH-green li a:hover {
    text-decoration: none;
    color: #F60;
}
.LH-menu {
    padding: 0;
    margin-top: 1px;
}
.LH-menu a{
    display: block;
    background: url("../assets/list.jpg") no-repeat center;
    color: #333;
    padding: 10px 0 10px 30px;
    margin: 0 0 3px 0;
    text-decoration: none;
    font-weight: bolder;
    font-size: 17px;
}
.LH-menu a:hover {
    color: #F60;
    background: url("../assets/list_hover.jpg") no-repeat center;
    font-weight: bolder;
}


.LH-right {
    margin-right: 25px;
    width: 750px;
    padding-bottom: 125px;
    height: 100%;
}
.LH-left >>> .el-tree {
    margin-top: 30px;
    background: transparent;
}
.LH-topic {
    margin-top: 30px;
    height: 58px;
    font-family: Cambria, Georgia, "Times New Roman", Times, serif;
    font-size: 25px;
    font-weight: bolder;
    color: #333;
    text-align: center;
}
.LH-topic img {
    vertical-align: middle;
}
.LH-mid {
    background-image: url("../assets/right_green.gif");
    background-repeat: no-repeat;
    width: 751px;
    margin-top: 0px;
    padding: 15px;
    box-sizing: border-box;
    align-items:flex-start;
}
.LH-introduce {
    width: 380px;
    margin-left: 15px;
    height: 155px;
    background-color: #F2F2F2;
    padding-left: 10px;
    padding-top: 5px;
    padding-right: 10px;
}
.LH-introduce h3 {
    font-size: 14px;
    margin: 0;
    line-height: 22px;
}
.LH-introduce-p {
    margin: 3px 0;
}
.LH-introduce-text {
    display: inline-block;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
}

.bshare-custom {
    text-align: right;
}
.bshare-custom a {
    display: inline-block;
    width: 19px;
    height: 16px;
}
.bshare-gplus {
    background: url("../assets/gplus.png") no-repeat;
}
.bshare-facebook {
    background: url("../assets/top_logos_sprite.png") no-repeat 0 -54px;
}
.bshare-instapaper {
    background: url("../assets/instapaper.png") no-repeat;
}
.bshare-msn {
    background: url("../assets/top_logos_sprite.png") no-repeat 0 -144px;
}
.bshare-twitter {
    background: url("../assets/top_logos_sprite.png") no-repeat 0 -342px;
}
.bshare-reddit {
    background: url("../assets/reddit.png") no-repeat;
}
.LH-main-button {
    margin: 0;
    padding: 0;
    margin-left: 15px;
}
.LH-main-button span {
    background-image: url("../assets/main_button.jpg");
    background-repeat: no-repeat;
    color: #00456B;
    height: 30px;
    width: 140px;
    display: block;
    font-weight: bold;
    padding-left: 25px;
    line-height: 28px;
    text-decoration: none;
    font-size: 12px;
    white-space: nowrap;
}
.LH-main-button a:hover {
    color: #F60;
    font-size: 12px;
}

.LH-footer {
    width: 750px;
    height: 45px;
    background-color: #d6d6c7;
    text-align: center;
    padding-top: 10px;
    font-size: 12px;
    position: absolute;
    bottom: 10px;
}
.LH-footer p{
    margin: 0;
    line-height: 22px;
}

.all-issues {
    color: #fff;
    font-size: 16px;
    font-family: Helvetica;
    font-weight: 600;
    background: #235ABF;
    text-align: center;
    margin-top: 20px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/index.vue